import {RouteObject} from "react-router";
import {ErrorPage} from "@src/Layers/ErrorLayer/ErrorPage.tsx";
import {RequestsPage} from "@src/Pages/RequestsPage/RequestsPage.tsx";
import {BackButtonViewPage} from "@src/CommonComponents/HeaderWithBackButton/HeaderWithBackButton.tsx";
import {LeaveRequest} from "@src/Pages/RequestsPage/LeaveRequest/LeaveRequest.tsx";
import {PurchaseRequest} from "./PurchaseRequest/PurchaseRequest";
import {OvertimeRequest} from "@src/Pages/RequestsPage/OvertimeRequest/OvertimeRequest.tsx";
import {EventRequest} from "@src/Pages/RequestsPage/EventRequest/EventRequest.tsx";
import {Outlet} from "react-router-dom";


export const path = 'requests'

export const route: RouteObject = {
    path,
    element: <Outlet/>,
    errorElement: <ErrorPage header={false}/>,
    children: [
        {
            path: "",
            element: <BackButtonViewPage title={"Requests"} backLink={"/"}><RequestsPage/></BackButtonViewPage>,
        },
        {
            path: "leave",
            element: (
                <BackButtonViewPage title={"Leave request"}
                                    backLink={"/requests/?tab=leave"}>
                    <LeaveRequest/>
                </BackButtonViewPage>
            ),
            errorElement: <ErrorPage header={false}/>,
            children: [
                {
                    path: ":requestId",
                    element: (
                        <BackButtonViewPage title={"Leave request"} backLink={"/requests/?tab=leave"}>
                            <LeaveRequest/>
                        </BackButtonViewPage>
                    ),
                    errorElement: <ErrorPage header={false}/>,
                },
            ]
        },

        {
            path: "purchase",
            element: <BackButtonViewPage title={"Expense request"}
                                         backLink={"/requests/?tab=purchase"}><PurchaseRequest/></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>,
            children: [
                {
                    path: ":requestId",
                    element: <BackButtonViewPage title={"Expense request"}
                                                 backLink={"/requests/?tab=purchase"}><PurchaseRequest/></BackButtonViewPage>,
                    errorElement: <ErrorPage header={false}/>,
                },
            ]
        },
        {
            path: "overtime",
            element: <BackButtonViewPage title={"Overtime request"}
                                         backLink={"/requests/?tab=overtime"}><OvertimeRequest/></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>,
            children: [
                {
                    path: ":requestId",
                    element: <BackButtonViewPage title={"Overtime request"}
                                                 backLink={"/requests/?tab=overtime"}><OvertimeRequest/></BackButtonViewPage>,
                    errorElement: <ErrorPage header={false}/>,
                },
            ]
        },
        {
            path: "event",
            element: <BackButtonViewPage title={"Event request"}
                                         backLink={"/requests/?tab=event"}><EventRequest/></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>,
            children: [
                {
                    path: ":requestId",
                    element: <BackButtonViewPage title={"Event request"}
                                                 backLink={"/requests/?tab=event"}><EventRequest/></BackButtonViewPage>,
                    errorElement: <ErrorPage header={false}/>,
                },
            ]
        },
    ]
}
